import Swal from "sweetalert2";
class LoadingService {
    static currentTitle = "";
    static currentMessage = "";
    static currentTimeout;
    static timeout = 500;
    static show(msg, title = "") {
        if (Swal.isVisible() &&
            LoadingService.currentTitle === title &&
            LoadingService.currentMessage === msg) {
            console.warn("Loading already visible with the same message");
            return;
        }
        LoadingService.currentTitle = title;
        LoadingService.currentMessage = msg;
        LoadingService.currentTimeout = setTimeout(() => {
            Swal.fire({
                title: title,
                text: msg,
                imageWidth: 60,
                imageHeight: 60,
                imageUrl: "/assets/img/loading-icon.gif",
                showConfirmButton: false,
                backdrop: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
            });
            LoadingService.currentTimeout = null;
        }, LoadingService.timeout);
    }
    static hide() {
        if (LoadingService.currentTimeout) {
            clearTimeout(LoadingService.currentTimeout);
        }
        Swal.close();
    }
}
export default LoadingService;
